t = require('views/internal/teacup-with-helpers')('closed_boards')

module.exports = ->
  t.div '.window-header', ->
    t.span '.window-header-icon.icon-lg.icon-archive'
    t.h2 '.window-title', ->
      t.format 'closed-boards'

  t.div '.window-main-col', ->
    t.div '.u-gutter.free-teams-out-of-space-banner.js-free-teams-out-of-space-banner'
    t.mustacheBlockInverted 'empty', ->
      t.div '.window-module.u-clearfix', ->
        t.ul '.archive-list.u-gutter.js-archive-items'
    t.mustacheBlock 'empty', ->
      t.p '.empty-list', ->
        t.format 'no-boards-have-been-closed'

  t.div '.window-sidebar', ->
    t.p '.helper', ->
      t.format 'you-have-to-have-been-a-board-admin-to-re-open-or-delete-a-closed-board'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/closed_boards.coffee